import type { PreloadedQuery } from 'react-relay';
import { LICENSE_STATE_ACTIVE } from '@jira/platform__license-state/src/license-state.tsx';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';

import { LICENSED_PRODUCTS } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER_QUERY, {
	type JiraHomeWithWorkSuggestionsQuery,
} from '@atlassian/jira-home/src/ui/__generated__/JiraHomeWithWorkSuggestionsQuery.graphql';

export const jiraHomeWorkSuggestionsIsDeveloperResource: RouteResource<
	PreloadedQuery<JiraHomeWithWorkSuggestionsQuery, Record<string, unknown>>
> = createRelayResource<JiraHomeWithWorkSuggestionsQuery>({
	type: 'JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER',
	getQuery: (_, { tenantContext }) => ({
		parameters: JIRA_HOME_WORK_SUGGESTIONS_IS_DEVELOPER_QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			isSoftwareLicensed:
				tenantContext.licensedProducts[LICENSED_PRODUCTS.JIRA_SOFTWARE] &&
				tenantContext.licenseStates?.software === LICENSE_STATE_ACTIVE,
		},
	}),
});
